import React, { useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { tickColor, baseFont, FALLBACK_COLORS } from './chartConstants';

const PriorityPieChart = ({ priorityData }) => {
    const chartData = useMemo(() => {
        if (!Array.isArray(priorityData) || priorityData.length === 0) return null;
        const filtered = priorityData.filter(p => p.tickets_count > 0);
        if (filtered.length === 0) return null;
        return {
            labels: filtered.map(p => p.name),
            datasets: [{
                data:                 filtered.map(p => p.tickets_count),
                backgroundColor:      filtered.map((p, i) => p.color || FALLBACK_COLORS[i % FALLBACK_COLORS.length]),
                hoverBackgroundColor: filtered.map((p, i) => p.color || FALLBACK_COLORS[i % FALLBACK_COLORS.length]),
                borderWidth: 2,
                borderColor: '#fff',
            }],
        };
    }, [priorityData]);

    const options = {
        maintainAspectRatio: false,
        legend: { display: true, position: 'bottom', labels: { fontFamily: baseFont, fontSize: 12, fontColor: tickColor, padding: 16, boxWidth: 14 } },
        tooltips: {
            backgroundColor: '#1F2937',
            titleFontFamily: baseFont, titleFontSize: 12, titleFontStyle: 'bold',
            bodyFontFamily: baseFont,  bodyFontSize: 12,
            xPadding: 10, yPadding: 10,
            callbacks: {
                label: (item, data) => {
                    const label = data.labels[item.index];
                    const val   = data.datasets[0].data[item.index];
                    const total = data.datasets[0].data.reduce((a, b) => a + b, 0);
                    const pct   = total > 0 ? Math.round((val / total) * 100) : 0;
                    return ` ${label}: ${val} ticket${val !== 1 ? 's' : ''} (${pct}%)`;
                },
            },
        },
    };

    if (!chartData) return <div style={{ color: tickColor, padding: 20 }}>No priority data available</div>;
    return <div style={{ height: '100%', minHeight: 160 }}><Doughnut data={chartData} options={options} /></div>;
};

export default PriorityPieChart;
